import React from "react";
import {GameModes} from "../../../../constants/EnumGameModes";
import {GameModePage} from "../../GameModePage";


type SoloRaceType = {}

export const SoloRace: React.FC<SoloRaceType> = () => {
    return (
        <GameModePage
            gameMode={GameModes.RACE_SOLO}
            showDifficultySelector={true}
            showBreadcrumb={true}
            containerPadding="xl:px-44"
        />
    );
}
